import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "./Constant";

function PlaceAnswerInGrid() {
  const [allAnswers, setAllAnswers] = useState([]); // Store fetched answers
  const [grid, setGrid] = useState([]); // 8x8 crossword-like grid state

  // Fetch server data
  const fetchAllAnswers = async () => {
    try {
      const response = await axios.post(`${API_URL}/questions_temp`, {
        CreatorTocken: localStorage.getItem("CreatorTocken"),
        game_id: localStorage.getItem("gameId"),
      });

      console.log("Fetched raw answers:", response.data);

      const answers = response.data.map((item) =>
        item.answer ? item.answer.split(",") : [],
      );

      console.log("Parsed answers:", answers);
      setAllAnswers(answers);
    } catch (error) {
      console.error("Error fetching answers:", error);
    }
  };

  useEffect(() => {
    fetchAllAnswers();
  }, []);

  useEffect(() => {
    if (allAnswers.length) {
      generateKrissKrossGrid();
    }
  }, [allAnswers]);

  // Create an empty 8x8 crossword-like grid
  const createEmptyGrid = () =>
    Array.from({ length: 8 }, () => Array(8).fill("0"));

  const canPlaceWordHorizontally = (grid, row, col, wordArray) => {
    // Check if the word fits horizontally
    if (col + wordArray.length > 8) return false;

    for (let idx = 0; idx < wordArray.length; idx++) {
      if (
        grid[row][col + idx] !== "0" &&
        grid[row][col + idx] !== wordArray[idx]
      ) {
        return false;
      }
    }
    return true;
  };

  const canPlaceWordVertically = (grid, row, col, wordArray) => {
    // Check if the word fits vertically
    if (row + wordArray.length > 8) return false;

    for (let idx = 0; idx < wordArray.length; idx++) {
      if (
        grid[row + idx][col] !== "0" &&
        grid[row + idx][col] !== wordArray[idx]
      ) {
        return false;
      }
    }
    return true;
  };

  const placeWordHorizontally = (grid, row, col, wordArray) => {
    for (let idx = 0; idx < wordArray.length; idx++) {
      grid[row][col + idx] = wordArray[idx];
    }
  };

  const placeWordVertically = (grid, row, col, wordArray) => {
    for (let idx = 0; idx < wordArray.length; idx++) {
      grid[row + idx][col] = wordArray[idx];
    }
  };

  const placeAnswersInGrid = (grid) => {
    allAnswers.forEach((answerArray) => {
      let placed = false;

      for (let row = 0; row < 8; row++) {
        for (let col = 0; col < 8; col++) {
          // Try horizontally
          if (
            canPlaceWordHorizontally(grid, row, col, answerArray) &&
            !placed
          ) {
            placeWordHorizontally(grid, row, col, answerArray);
            placed = true;
          }

          // If not placed, try vertically
          if (canPlaceWordVertically(grid, row, col, answerArray) && !placed) {
            placeWordVertically(grid, row, col, answerArray);
            placed = true;
          }
        }
      }
    });

    return grid;
  };

  const generateKrissKrossGrid = () => {
    let workingGrid = createEmptyGrid();

    workingGrid = placeAnswersInGrid(workingGrid);

    console.log("Final generated shared crossword grid:", workingGrid);

    setGrid(workingGrid);
  };

  return (
    <div>
      <h1>Kriss-Kross Shared Grid Generator</h1>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(8, 30px)`,
          gap: "2px",
        }}
      >
        {grid.map((row, rowIndex) =>
          row.map((cell, colIndex) => (
            <div
              key={`${rowIndex}-${colIndex}`}
              style={{
                width: "30px",
                height: "30px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid #ccc",
                backgroundColor: cell === "0" ? "#f0f0f0" : "#fff",
              }}
            >
              {cell !== "0" ? cell : ""}
            </div>
          )),
        )}
      </div>
    </div>
  );
}

export default PlaceAnswerInGrid;
